import React, { FC } from 'react';
import classNames from 'classnames';

import type { RootMenuItem as RootMenuItemType } from '../../types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import RootMenuIcon from './Icon';

import styles from '../../styles/LeftMenu.module.scss';

type IconCellProps = {
  entry: RootMenuItemType;
};

const iconCellGroup = [MENU_ITEM_TYPE.TOURNAMENT, MENU_ITEM_TYPE.UNION, MENU_ITEM_TYPE.STAGE];

const IconCell: FC<IconCellProps> = ({ entry }) => {
  const isIconCellGroup = iconCellGroup.includes(entry.type);

  return (
    <div className={classNames(styles.iconCell, {
      [styles.iconCellGroup]: isIconCellGroup,
    })}>
      <RootMenuIcon entry={entry} />
    </div>
  );
};

export default IconCell;
